import { Outlet } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MobileTabBar from '@/components/feature/MobileTabBar';

export default function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50 pb-16 md:pb-0">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <MobileTabBar />
    </div>
  );
}